import { Vector3 } from '@canvas/vector';

// Current user selection color is always blue (#1D7AFC), as per functional spec
export const currentUserSelectionColor = Vector3.fromHexColor('#1D7AFC');
// Multi selection internal color is always light blue (#85B8FF), as per functional spec
export const multiSelectionColor = Vector3.fromHexColor('#85B8FF');
// Selection color of locked elements
export const lockedSelectionColor = Vector3.fromHexColor('#8993A5');
// Selection color of private elements
export const privateSelectionColor = Vector3.fromHexColor('#8590A2');
// Color for equidistant spacing guides
export const equidistantSpacingGuideColor = Vector3.fromHexColor('#AE2E24');
